export default __webpack_public_path__ + "static/media/logo_app.cf320c39.svg";